export const getFileDurationFromTimestamp = (fileDuration) => {
    const millisecondsConverted = fileDuration / 1000;
    const hours = Math.floor(millisecondsConverted / 3600);
    const minutes = Math.floor((millisecondsConverted % 3600) / 60);
    const seconds = Math.floor(millisecondsConverted % 60);

    return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);
}